@layer design-system {
  .root {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-direction: row;

    &.isReversed {
      flex-direction: row-reverse;

      .sortIcon {
        transform: scaleX(-1);
      }
    }
  }

  .filterIcon {
    fill: var(--icon-disabled);
  }

  .pinIcon {
    fill: var(--icon-disabled);
  }

  .sortIcon {
    fill: var(--icon-default);
  }
}
